import React from "react";
import "./App.css";
import Main from "./components/Main/main";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
